interface IconDownProps {
  className?: string;
}

const IconDown = ({ className = '' }: IconDownProps) => (
  <span
    className={`flex items-center justify-center w-[18px] h-[18px] rounded-full border border-[#5C5C5C] ${className}`}
  >
    <svg
      fill="none"
      height="4"
      viewBox="0 0 6 4"
      width="6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 2.79289L0.731617 0.146447C0.56425 -0.0488155 0.292893 -0.0488155 0.125526 0.146447C-0.0418419 0.341709 -0.0418419 0.658291 0.125526 0.853553L2.69695 3.85355C2.86432 4.04882 3.13568 4.04882 3.30305 3.85355L5.87447 0.853553C6.04184 0.658291 6.04184 0.341709 5.87447 0.146447C5.70711 -0.0488155 5.43575 -0.0488155 5.26838 0.146447L3 2.79289Z"
        fill="#565656"
      />
      <mask
        height="4"
        id="mask0_4281_78"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="6"
        x="0"
        y="0"
      >
        <path
          d="M3 2.79289L0.731617 0.146447C0.56425 -0.0488155 0.292893 -0.0488155 0.125526 0.146447C-0.0418419 0.341709 -0.0418419 0.658291 0.125526 0.853553L2.69695 3.85355C2.86432 4.04882 3.13568 4.04882 3.30305 3.85355L5.87447 0.853553C6.04184 0.658291 6.04184 0.341709 5.87447 0.146447C5.70711 -0.0488155 5.43575 -0.0488155 5.26838 0.146447L3 2.79289Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4281_78)" />
    </svg>
  </span>
);

export default IconDown;
